export default __webpack_public_path__ + "static/media/background-soft-services.ea07e39a.svg";